import {Component, ElementRef, Input, Output, Renderer2} from '@angular/core';
import {Participant, GlobalServiceProvider} from "../../../providers/global.service";
import {ApiServiceProvider} from "../../../providers/api.service";
import {Observable} from "rxjs/Observable";
import {filter} from 'rxjs/operators';

import 'rxjs/add/observable/of';
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {EventEmitter} from "@angular/core";

// import {CommandProvider} from "../../../providers/command/command";


/**
 * Generated class for the ParticipantListCmdComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */

declare var window;

@Component({
  selector: 'participant-list-cmd',
  templateUrl: 'participant-list-cmd.html'
  // template:'<div *ngFor="let c of participants" (click)="clicked(c)">{{c.username}}</div>'
})

export class ParticipantListCmdComponent {

  text: string;
  participants:Array<Participant>;

  @Input() public criteria: Object;



  // private command:CommandProvider;

  constructor(
    private elementRef: ElementRef,

    private fb: FormBuilder,
    private renderer: Renderer2) {
    console.log('Hello ParticipantListCmdComponent Component');
  }


  ngOnInit() {

  }

  ngOnDestroy() {
    // this.participantObservable.unsubscribe();
  }


  public dispatchParticipantCommand(p) {
    console.log("clicked", p);

    // let cmd = CmdObj.parse(`participant`);

    // cmd[0].arguments=p;
    // let event = new CustomEvent('commandIssued', {detail:cmd, bubbles:true});
    // debugger;
    // this.elementRef.nativeElement.dispatchEvent(event);
  }


  public modifyValues() {
    // this.participants[0].username = new Date().getTime().toString();
    // this.global.createParticipant();
  }


  makeEditable(participant) {
    let formObj: Array<FormControl> = [];
    //edit username? no
    //edit comments
    //edit name
    //edit email
    //edit groups
    //edit variables
    // formObj['comments'] = new FormControl(participant.comments);
    // formObj['name'] = new FormControl(participant.name);
    // formObj['email'] = new FormControl(participant.email);
    // formObj['groups'] = new FormControl(participant.groups);
    // formObj['variables'] = new FormControl(participant.variables);
    //
    // this.participantForm = this.fb.group(formObj);
    // this.renderer.appendChild(this.element.nativeElement, this.participantForm)
  }


  setData(data){
   this.participants=data;
  }


}



// WEBPACK FOOTER //
// ./src/components/commands/participant-list-cmd/participant-list-cmd.ts